import { Status } from "@/routes/properties";

export const getFormTitle = (status: string) => {
	if (status === Status.AVAILABLE) return "Interesse? Laat je gegevens achter";
	if (status === Status.SOON)
		return "Direct geïnformeerd worden bij start verkoop? Laat hieronder uw gegevens achter.";

	return "Direct geïnformeerd worden wanneer iets soortgelijks op de markt komt? Laat hieronder uw gegevens achter.";
};

export function truncateDescription(description: string) {
	return description.length > 157
		? description.substring(0, 157) + "..."
		: description;
}
